export const updatePercentageAndStep = (stepMapping, currentStep, wizardSteps) => {
    const totalSteps = Object.keys(stepMapping).length

    const currentWizardStep = Object.entries(wizardSteps).find(([key, value]) => value === stepMapping)?.[0] || null

    const percentage = percentageCalculator(currentStep, totalSteps)

    return {
        percentage,
        wizardStep: currentWizardStep,
        childWizzardStep: currentStep,
    }
}

export const percentageCalculator = (stepNumber, totalStepNumber) =>
    Math.round(((stepNumber - 1) / totalStepNumber) * 100)
